import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/styles/tailwind.css";
import { VueCookieNext } from "vue-cookie-next";
// import ElementPlus from "element-plus";
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElAlert,
  ElSelect,
  ElOption,
} from "element-plus";
import "@/assets/styles/theme/index.css";
import '@/index.css'
// import "element-plus/lib/theme-chalk/index.css";

//TODO: use not complete ElementPlus
const app = createApp(App);
app.use(VueCookieNext);
app.use(ElButton);
app.use(ElForm);
app.use(ElFormItem);
app.use(ElInput);
app.use(ElAlert);
app.use(ElSelect);
app.use(ElOption);
app.mount("#app");
